import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getPermissions, getCompany, getSubcompany } from 'auth/selectors';

import * as NotificationsHistoric from 'notifications_historic/components';

class NotificationsHistoricRowContainer extends Component {
  render = () => (
    <NotificationsHistoric.Row
      handleToggle={this.props.handleToggle}
      notificationHistoric={this.props.notificationHistoric}
      company={this.props.company}
      subcompany={this.props.subcompany}
      permissions={this.props.permissions}
    />
  );
}

const mapStateToProps = (state) => ({
  permissions: getPermissions(state),
  company: getCompany(state),
  subcompany: getSubcompany(state),
});

export default connect(mapStateToProps, null)(NotificationsHistoricRowContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_historic/containers/NotificationHistoricRowContainer.js